jQuery(function($){


  // Anchor smooth scrolls
  $("body").on("click",".a-link",function(o){o.preventDefault();document.querySelector(this.getAttribute('href')).scrollIntoView({behavior: 'smooth'});$("body").removeClass("show-menu")});

  
  // Fixed menu when scrolling down page
  const body = document.body;
  let lastScroll = 0;
  
  
  if (jQuery(window).width() < 1023) {

    window.addEventListener("scroll", () => {
        const s = window.pageYOffset;
        s <= 0 ||
            (s <= 1000 ? body.classList.remove("fixed-menu") : s > 1000 && body.classList.add("fixed-menu"),(lastScroll = s));
    });

  }  
       
  if (jQuery(window).width() > 1024) {

    window.addEventListener("scroll", () => {
        const s = window.pageYOffset;
        s <= 0 ||
            (s <= 300 ? body.classList.remove("fixed-menu") : s > 300 && body.classList.add("fixed-menu"),(lastScroll = s));
    });

  }
  
});